import { IPromoCode, IPromoCodeComponent } from '../../types/coupon';
import { PromoCodeDiscountType } from '../../types/constants';
import useHelpers from '../utility/useHelpers';
import collect from 'collect.js';

export default function usePromoCode() {
  const { formatCurrency } = useHelpers();

  const getCurrentComponent = (promoCode: IPromoCode): IPromoCodeComponent => {
    return promoCode.components.find((item) => !item.is_used);
  };

  const formatDiscount = (
    promoCode: IPromoCode | IPromoCodeComponent,
    discountType: PromoCodeDiscountType,
  ): string => {
    const formatter = (discount: number) =>
      ({
        [PromoCodeDiscountType.Percentage]: `${discount}%`,
        [PromoCodeDiscountType.FixedAmount]: formatCurrency(discount),
      })[discountType];

    if ('components' in promoCode) {
      return discountType === PromoCodeDiscountType.FixedAmount
        ? formatter(+collect(promoCode.components).sum('discount'))
        : collect(promoCode.components)
            .map((item) => formatter(item.discount))
            .implode(' / ');
    }

    return formatter(promoCode.discount);
  };

  return {
    getCurrentComponent,
    formatDiscount,
  };
}
